/**
 * TOPのモーダル
 * @constructor
 */
class Modal {
  constructor() {
  }
  /**
   * TOPのモーダル
   */
  init() {
    const self = this;

    //モーダル開く
    $(function () {
      let scrollpos;
      $('.js-openModal').on('click', function () { 
        let num = $(this).data('modal');
        $('#modal_' + num).css('display', 'block');
        $('.js-modal').fadeIn(200);
        $('#q_01').css('display', 'block');
        scrollpos = $(window).scrollTop();
        $('body').addClass('fixed').css({
          'top': -scrollpos,
          'right': 0,
          'left': 0
        });
        $('.p-yesnoItemWrap__arrow').removeClass('is-active');
        $('.p-yesnoItemWrap__arrow--01').addClass('is-active');
        $('.p-yesnoList__ttl').removeClass('is-active');
        $('.p-yesnoList__ttl--ques').addClass('is-active');
        return false;
      })

      // モーダル閉じる
      $('.js-closeModal,.m-modal__bg').on('click', function () { 
        $('.js-modal').fadeOut(200, function () {
          $('.js-modal').css('display', 'none');
          $('.m-modalCt').css('display', 'none');
          $('.m-modalCt__item').css('display', 'none');
          $('body').removeClass('fixed').css({
            'top': 0
          });
          $('html,body').animate({
            scrollTop: scrollpos
          }, 0);
        });
      })
    })


    $('.js-btn').on('click', (e) => {
      //診断コンテンツの質問が切り替わる
      this.changeQuestion(e.currentTarget);
      //YES・NOボタン押すと矢印の画像が変わる
      this.changeArrow(e.currentTarget);
    });
    
    $('.js-ansBtn').on('click', (e) => {
      //４問目のボタン押すと、タイトルが「あなたにオススメの馬券はこちら!!」に変わる
      this.changeTtl(e.currentTarget);
    })
    
  }


  changeQuestion(el) {
    $(el).closest("div").css("display", "none");
    let id = $(el).attr("href");
    $(id).fadeIn();
    return false;
  }

  changeArrow(el) {
    const num = $(el).data('arrow');
    $('.p-yesnoItemWrap__arrow').removeClass('is-active');
    $('.p-yesnoItemWrap__arrow--' + num).addClass('is-active');
  }

  changeTtl() {
    $('.p-yesnoList__ttl').removeClass('is-active');
    $('.p-yesnoList__ttl--ans').addClass('is-active');
  }

}

export default Modal;
